import axios from 'axios';
import { CORE_API_URL } from '../config';
import { apiResponseInterceptor, apiErrorInterceptor, TIMEOUT, apiRequestInterceptor } from './ApiHelpers';

/**
 * Create a new axios instance
 */
const CoreInstance = axios.create({
  baseURL: CORE_API_URL,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

CoreInstance.interceptors.request.use(apiRequestInterceptor);
CoreInstance.interceptors.response.use(apiResponseInterceptor, apiErrorInterceptor);

/**
 * Set authentication token
 */
export const setCoreAuthToken = (token) => {
  if (token) CoreInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export default CoreInstance;
